// extracted by mini-css-extract-plugin
export default {"shell_prompt":"shellprompt__shell_prompt","spinner":"shellprompt__spinner","shell_form":"shellprompt__shell_form","control":"shellprompt__control"};